import {
  createContext,
  useContext,
} from "react";

export const BoardContext = createContext();


export const useBoardProvider = () => {
  const context = useContext(BoardContext);
  if (!context) {
    throw new Error("useBoardProvider must be used within a BoardProvider");
  }
  return context;
};
